import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { useCpdNewIndicator } from './useCpdNewIndicator';

interface ICPDLinkProps extends React.PropsWithChildren {
  url: string;
  onClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const CPDLink: React.FC<ICPDLinkProps> = ({ onClick, url, children }) => {
  const { showIndicator } = useCpdNewIndicator();

  return (
    <a className={clsx(styles['link'], showIndicator ? styles['indicator'] : undefined)} href={url} onClick={onClick}>
      {children}
    </a>
  );
};
